import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateIconGrid(section, textLines, hr, icons) {

  // Inidividual tweens
  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated hr 
  let hrTween = hr ? gsap.to(hr, {
    width: "100%",
    duration: 0.4,
    opacity: 1
  }) : null;

  // Icons 
  let iconsTween = icons ? gsap.to(icons, {
    duration: 0.8,
    opacity: 1,
    y: 0,
    stagger: {
      each: 0.25,
      from: "start",
    },
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 90%",
    },
  });

  tl 
    .addLabel("gridStart")
    .add(textLinesTween, "gridStart")
    .add(hrTween, "gridStart+=0.4")
    .add(iconsTween);
}